import styled from "styled-components";
import { FlexCol } from "@quarks";

export const StyledContainer = styled(FlexCol)`
  gap: 40px;
  height: 100%;
  overflow: auto;
  justify-content: flex-start;
  padding: 20px;
`;
